import { Toaster as SonnerToaster } from 'sonner';

/**
 * Sonner-based global toaster wired to the design system: muted surface,
 * border, and 200ms-or-less animation per the spec. The web app renders
 * exactly one of these inside `<AppShell />`'s `overlays` slot.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={4000}
      toastOptions={{
        classNames: {
          toast:
            'bg-surface-elevated border border-border text-fg text-sm rounded-md shadow-md',
          title: 'text-fg font-medium',
          description: 'text-fg-secondary',
          success: 'text-success',
          error: 'text-danger',
          warning: 'text-warning',
        },
      }}
    />
  );
}

// Re-export the imperative API so apps can `import { toast } from '@sitewise/ui'`.
export { toast } from 'sonner';
